module.exports = __webpack_public_path__ + "img/card.e3b1a1ff.svg";